import React from 'react';
import './TopBanner.css'

const TopBanner = () => {
    return (
        <div className="background">
            <div className="row  d-flex align-items-center" style={{ margin: 0, height: "100%" }}>
                <div className="col">
                    <h2 style={{ color: "white" }}>Hi there, my name is</h2>
                    <h1 style={{ color: "white" }}> AKTARUZZAMAN RIDOY</h1>
                    <a href="https://drive.google.com/file/d/1t3K6HGBfb0hO8kXC2fkCuwnyEHAZjVS-/view?usp=sharing" target="_blank"
                        rel="noopener noreferrer"><button type="button" className="btn btn-success">Download Resume</button></a>
                </div>
                <div className="col">
                    2 of 2
                </div>
            </div>
        </div>
    );
};

export default TopBanner;